<template>
  <fragment>
    <tr :class="item.newlyAdded && 'newly-added-row'" v-if="show">
      <td :style="getPadding()">
        <v-btn v-if="hasChildren(item)" icon @click="changeShowChildren(item)">
          <v-icon>{{
            item.showChildren ? 'mdi-chevron-down' : 'mdi-chevron-right'
          }}</v-icon>
        </v-btn>
        <v-icon v-else>mdi-circle-small</v-icon>
      </td>
      <td>
        <template>
          <div class="nowrap">
            <el-table-action :item="item" @deleteItem="deleteItem(item)" />
          </div>
        </template>
      </td>
      <td>{{ item.code }}</td>
      <td>{{ getInstitutionTitle(item) }}</td>
      <td>{{ item.pasis_code }}</td>
      <td>{{ item.title_lt }}</td>
      <td>{{ item.title_en }}</td>
    </tr>
    <el-table-mandate-service-row
      :show="item.showChildren && show"
      v-for="child in item.children"
      :key="child.id"
      :item="child"
      :level="getLevel()"
      @deleteItem="deleteItem"
    />
  </fragment>
</template>

<script>
import { Fragment } from 'vue-frag'
export default {
  name: 'ElTableMandateServiceRow',
  props: {
    item: [Array, Object],
    level: Number,
    show: Boolean,
  },
  data() {
    return {}
  },
  components: {
    Fragment,
  },
  methods: {
    hasChildren(item) {
      return item.children.length > 0
    },
    changeShowChildren(item) {
      let logic = !item.showChildren
      this.$set(item, 'showChildren', logic)
    },
    getInstitutionTitle(item) {
      return item.institution?.fullname || ''
    },
    deleteItem(item) {
      this.$emit('deleteItem', item)
    },
    cardMargin() {
      let number = this.level >= 5 ? 5 : this.level
      let padding = (number - 1) * 20
      return `margin-left:${padding}px;width: 600px;`
    },
    getPadding() {
      let padding = (this.level - 1) * 10
      return `padding-left:${padding}px;`
    },
    getLevel() {
      return this.level + 1
    },
  },
}
</script>
<style lang="scss" scoped></style>
